import { apiLeague } from "api"
import Skeleton from "components/Skeleton"
import Image from "next/legacy/image"
import { useEffect, useState } from "react"
const timeNow = Date.now()
function Match({ id }) {
  const [matchs, setMatchs] = useState([])
  const [loading, setLoading] = useState(false)

  async function fetch() {
    setLoading(true)
    try {
      const { data, success } = await apiLeague.getMatchOfLuague({
        league_id: id
      })
      setMatchs(data)
    } catch (error) {
      console.log(error.response)
    } finally {
      setLoading(false)
    }
  }
  function ScrollBar() {
    if (matchs) {
      const found = matchs.find((element) => element?.matchs[0]?.status === 0)
      const el = document.getElementById(found?.round_name)
      el?.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }
  // function ScrollBar() {
  //   let result
  //   for (let i; i <= matchs?.length; i++) {
  //     console.log("dddsdfdsfsdf")
  //     for (let j; j <= matchs[i]?.matchs?.length; j++) {
  //       console.log(matchs[i]?.matchs[j], "dddddd")
  //       if (matchs[i]?.matchs[j]?.time >= 1672729178105) {
  //         result = matchs[i]?.matchs[j]
  //         break
  //       }
  //     }
  //   }
  //   console.log(result, " hien thi result")
  //   return result
  // }

  useEffect(() => {
    setTimeout(() => {
      if (matchs.length > 0) ScrollBar()
    }, [400])
  }, [matchs])

  useEffect(() => {
    fetch()
  }, [])

  return (
    <div>
      {loading ? (
        <Skeleton type="match"></Skeleton>
      ) : (
        <>
          {matchs.length > 0 ? (
            <>
              {matchs?.map((item, index) => {
                const { round_name } = item
                return (
                  <div key={index} className="mb-8 scroll_to" id={round_name}>
                    {round_name && (
                      <div className="font-bold bg-opaque-100 w-full rounded-lg px-4 py-2">
                        <div className="ml-1">
                          {Number(round_name) > 0 ? <>Round {round_name}</> : <>{round_name}</>}
                        </div>
                      </div>
                    )}
                    <div className="grid gap-2 grid-cols-1 lg:grid-cols-2 mt-4 text-dark-300">
                      {item?.matchs?.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className="col-span-1 bg-dark p-4 rounded hover:bg-dark-900"
                            // id={item?.id}
                          >
                            <Mycard {...item} />
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
            </>
          ) : (
            <div className="text-center flex justify-center items-center h-full text-sm">
              Lịch thi đấu chưa được cập nhật
            </div>
          )}
        </>
      )}
    </div>
  )
}
export default Match

function Mycard({ home_logo, home_name, home_score, away_name, away_logo, away_score, time, status }) {
  const [imageHome, setImageHome] = useState(home_logo)
  const [imageAway, setImageAway] = useState(away_logo)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    if (window.innerWidth < 768) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }, [])

  return (
    <>
      {isMobile ? (
        <div className="">
          {/* <div className="col-span-1" dangerouslySetInnerHTML={{ __html: ConvertTime(time) }}></div> */}
          <div className="ml-1 flex items-center justify-center mb-4">
            <div className=" text-xsfont-semibold mr-1">{GetHours(time)}</div>
            <div className="text-xs ml-1">{GetDays(time)}</div>
          </div>
          <div className="grid grid-cols-10">
            <div className="col-span-4 flex items-center justify-end mr-2">
              <div className="font-semibold text-sm col-span-3 mr-2">{home_name}</div>
              <div className="col-span-1">
                <Image
                  src={imageHome || "https://stvinaprod.vtvcab.vn/797864df-e895-426e-8573-210ca0d4b26c.png"}
                  width={20}
                  height={20}
                  alt={home_name}
                  onError={() => setImageHome("https://stvinaprod.vtvcab.vn/76dd900f-acab-49c5-b973-d3faf3b5f4c3.png")}
                />
              </div>
            </div>
            <div
              className="border-dark-700 border rounded w-full flex justify-center items-center col-span-2"
              // style={{ border: "red solid 2px" }}
            >
              <div className="text-dark-100 font-bold text-base">
                {status === -1 ? (
                  <>
                    {home_score} &nbsp;- &nbsp;{away_score}
                  </>
                ) : (
                  <>-</>
                )}
              </div>
            </div>
            <div className="col-span-4 flex items-center justify-start ml-2">
              <div className="col-span-1 ">
                <Image
                  src={imageAway || "https://stvinaprod.vtvcab.vn/797864df-e895-426e-8573-210ca0d4b26c.png"}
                  width={20}
                  height={20}
                  alt={away_name}
                  onError={() => setImageAway("https://stvinaprod.vtvcab.vn/76dd900f-acab-49c5-b973-d3faf3b5f4c3.png")}
                />
              </div>
              <div className="font-semibold text-sm col-span-3 flex justify-start items-center ml-2">{away_name}</div>
            </div>
          </div>
        </div>
      ) : (
        <div className="grid gap-2 grid-cols-7">
          {/* <div className="col-span-1" dangerouslySetInnerHTML={{ __html: ConvertTime(time) }}></div> */}
          <div className="col-span-1 text-left ml-1">
            <div className="font-semibold">{GetHours(time)}</div>
            <div className="text-xs text-primary-300">{GetDays(time)}</div>
          </div>
          <div className="col-span-6">
            <div className="grid grid-cols-2 gap-4 relative">
              <div className="col-span-1 grid grid-cols-5">
                <span className="font-semibold text-sm col-span-3 flex justify-end items-center mr-2">{home_name}</span>
                <div className="col-span-1 text-right">
                  <Image
                    src={imageHome || "https://stvinaprod.vtvcab.vn/797864df-e895-426e-8573-210ca0d4b26c.png"}
                    width={48}
                    height={48}
                    alt={home_name}
                    onError={() =>
                      setImageHome("https://stvinaprod.vtvcab.vn/76dd900f-acab-49c5-b973-d3faf3b5f4c3.png")
                    }
                  />
                </div>
                <div className="col-span-1"></div>
              </div>
              <div
                className="text-center absolute left-1/2 top-0 transform  -translate-x-1/2 border-dark-700 border rounded w-[96px] mt-2"
                // style={{ border: "red solid 2px" }}
              >
                <div className="text-dark-100 font-bold text-lg">
                  {status === -1 ? (
                    <>
                      {home_score} &nbsp;- &nbsp;{away_score}
                    </>
                  ) : (
                    <>-</>
                  )}
                </div>
              </div>
              <div className="col-span-1 grid grid-cols-5">
                <div className="col-span-1"></div>
                <div className="col-span-1 text-left">
                  <Image
                    src={imageAway || "https://stvinaprod.vtvcab.vn/797864df-e895-426e-8573-210ca0d4b26c.png"}
                    width={48}
                    height={48}
                    alt={away_name}
                    onError={() =>
                      setImageAway("https://stvinaprod.vtvcab.vn/76dd900f-acab-49c5-b973-d3faf3b5f4c3.png")
                    }
                  />
                </div>
                <span className="font-semibold text-sm col-span-3 flex justify-start items-center ml-2">
                  {away_name}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

function GetHours(time) {
  let unix_timestamp = time
  var date = new Date(unix_timestamp * 1000)
  var hours = date.getHours()
  var minutes = "0" + date.getMinutes()
  var formattedTime = hours + ":" + minutes.substr(-2)
  return formattedTime
}

function GetDays(time) {
  let unix_timestamp = time
  var date = new Date(unix_timestamp * 1000)
  var day = date.getDate()
  var month = date.getMonth() + 1
  var formattedTime = day + " " + "tháng" + " " + month
  return formattedTime
}
